export default {
  title: 'ETSIMÄSI SIVUN TÄYTYY OLLA JOSSAIN TÄÄLLÄ...',
  description: 'Etsitkö jotakin alla olevista sivuista?',
  not_found: 'Emme löydä syöttämääsi osoitetta. Tarkista, että se on kirjoitettu oikein.',
  no_restaurants: {
    title: 'Tämä liike ei vielä ota vastaan verkkotilauksia',
    description: 'Käy katsomassa pian uudelleen.',
  },
  toasts: {
    failed_to_load_stores: 'Liikkeiden lataaminen epäonnistui, päivitä sivu',
  },
};
